jQuery(document).ready(function($){
	carousel();
	dropClick();
	initMobileNav();
	initSelecttext();
	initWidgetCollapse();
	dropdownHoverInit();
	initToggles();
	initTabs();

	$(window).load(function(){

		if($('.filter-list li').length) {
			equalHeight('.filter-list li');
		}
		
	});

});

jQuery(window).on('load', function(){
	//initFilter();
});


// dropdown hover init
function dropdownHoverInit() {

	enquire.register("screen and (min-width: 992px)", {

		match : function() {

			if (!Modernizr.touch) {

				jQuery('ul.main-nav > li.dropdown').hover(function() {
					jQuery(this).find('> .dropdown-menu').stop(true, true).delay(100).fadeIn(500);
				}, function() {
					jQuery(this).find('> .dropdown-menu').stop(true, true).delay(100).fadeOut(500);
				});


				jQuery('ul.submenu > li.dropdown').hover(function() {
					jQuery(this).find('> .submenu').stop(true, true).delay(100).fadeIn(500);
				}, function() {
					jQuery(this).find('> .submenu').stop(true, true).delay(100).fadeOut(500);
				});


			}
		}
	});

	enquire.register("screen and (max-width: 991px)", {

		match : function() {

			jQuery('ul.main-nav > li.dropdown > ul.submenu > li.dropdown a').on('click', function(event) {
				// event.stopPropagation();

				jQuery(this).toggleClass('active').next().stop(true, true).slideToggle(500);

			});

		}

	});


}

// mobile menu init
function initMobileNav() {
	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener',
		menuDrop: '.nav-wrap'
	});
}

// init carousel
function carousel() {
	jQuery('.carousel').slick({
		infinite: true,
		speed: 500,
		fade: true,
		autoplay: true,
		autoplaySpeed: 4000,
		cssEase: 'linear',
		prevArrow: '<a href="#" class="slick-prev"></a>',
		nextArrow: '<a href="#" class="slick-next"></a>'
	});
}

// init dropClick
function dropClick() {
	jQuery('.search-hold .dropdown-menu').on('click', function(event){
		event.stopPropagation();
	});
}

// init Filter
function initFilter() {
	var $grid = jQuery('.filter-list').isotope({
		filter: '.fstories',
		layoutMode: 'fitRows',
	});

	// filter items on button click
	jQuery('.filter').on( 'click', 'a', function() {
		jQuery('.filter a').removeClass('active');
		var filterValue = jQuery(this).attr('data-filter');
		$grid.isotope({ filter: filterValue });
		jQuery(this).addClass('active');
		return false;
	});
}

function initSelecttext() {
	var activeText = jQuery('.filter .active').text();
	var opener = jQuery('.filter-opener');
	var openerText = opener.find('span').text(activeText);

	jQuery('.filter li').click(function() {
		jQuery('.filter-wrap').removeClass('open');
		var text = jQuery(this).text();
		openerText.text(text);
	});
}

function initWidgetCollapse() {
	jQuery('.widget').each(function() {
		var item = jQuery(this);
		var drop = item.find('ul');
		var link = item.find('h2').eq(0);

		link.click(function(){
			item.toggleClass('active');
			drop.slideToggle(400);
		});
	});
}

function initToggles() {
	jQuery('.toggle').find('.box').hide();

	jQuery('.toggle').on('click', '.trigger', function () {
		// Control ARIA landmarks on open
		if (jQuery(this).attr('aria-expanded', 'false')) {
			jQuery(this).attr('aria-expanded', 'true');
			jQuery(this).next().attr('aria-hidden', 'false');
		}

		// Control ARIA landmarks on close
		if (
			jQuery(this).hasClass('active') &&
			jQuery(this).attr('aria-expanded', 'true')
		) {
			jQuery(this).attr('aria-expanded', 'false');
			jQuery(this).next().attr('aria-hidden', 'true');
		}

		jQuery(this)
			.toggleClass('active')
			.next()
			.stop(true, true)
			.slideToggle('normal');

		return false;
	});
}

function initTabs() {
	jQuery('.tabs').on( "click", "button", function(e){
		e.preventDefault();

		var $this = jQuery(this);
		var $parents = $this.parents('.tabs-wrapper');

		var tab_id = $this.attr('data-tab');

		$parents.find('.tabs button').removeClass('tab-current').attr("aria-selected", "false");
		$parents.find('.tab-content').removeClass('tab-current').attr("aria-hidden", "true");

		$this.addClass('tab-current').attr("aria-selected", "true");
		jQuery("#"+tab_id).addClass('tab-current').attr("aria-hidden", "false");
		// get current position, focus, then maintain position so focus doesn't move screen
		var x = window.scrollX, y = window.scrollY;
		window.scrollTo(x,y);
	});

	// Add arrow key functionality to tabs
	jQuery('[role=tablist]').keydown(function(e) {
		if (e.keyCode === 37) {
			jQuery("[aria-selected=true]").prev().click().focus();
			e.preventDefault();
		}
		if (e.keyCode === 38) {
			jQuery("[aria-selected=true]").prev().click().focus();
			e.preventDefault();
		}
		if (e.keyCode === 39) {
			jQuery("[aria-selected=true]").next().click().focus();
			e.preventDefault();
		}
		if (e.keyCode === 40) {
			jQuery("[aria-selected=true]").next().click().focus();
			e.preventDefault();
		}
	});
}